export default __webpack_public_path__ + "static/tooltip-interactive-2-do-dark-de8cc8e7c6cb1f5111f506c9b8edf9a679509e5c97eb7f280e6934c7ab0e047f.png";